import { rootApi } from "..";
import { attendanceService } from "../../../Api/Services/AttendanceService";
import {
  hrService,
  IMarkBulkEmployeeAttendanceCorrectionParams,
} from "../../../Api/Services/HRService";
import {
  IAssignAttendancePolicyPayload,
  IAttendanceCorrectionFormData,
  IAttendanceDetaislArgs,
  IAttendancePolicyListPayload,
  IAttendancePolicyPayload,
} from "../../../features/attendance/types";
import { makeEndpoints } from "../../../utils/rtkQueryFactory";

export const employeeAttendanceEndpoints = [
  {
    name: "listAttendance",
    type: "query",
    serviceFn: ({
      activeYear,
      endDate,
      startDate,
      userId,
    }: IAttendanceDetaislArgs) =>
      attendanceService.getAttendanceDetails(
        activeYear,
        startDate,
        endDate,
        userId
      ),
    tagType: "EmployeeAttendanceInfo",
  },
  {
    name: "updateAttendanceCorrection",
    type: "mutation",
    serviceFn: (correctionAttendanceData: IAttendanceCorrectionFormData) =>
      attendanceService.attedanceCorrection(correctionAttendanceData),
    tagType: "EmployeeAttendanceInfo",
  },
  {
    name: "updateBulkAttendanceCorrection",
    type: "mutation",
    serviceFn: ({
      dates,
      in_time,
      out_time,
      user_id,
    }: IMarkBulkEmployeeAttendanceCorrectionParams) =>
      hrService.markBulkEmployeeAttendanceCorrection({
        in_time,
        out_time,
        user_id,
        dates,
      }),
  },
  {
    name: "punchAttendanceEmployee",
    type: "mutation",
    serviceFn: (attendanceFormData: FormData) =>
      attendanceService.markAttendanceUser(attendanceFormData),
    tagType: "EmployeeInfo",
  },
  {
    name: "getAttendancePolicyList",
    type: "query",
    serviceFn: (payload: IAttendancePolicyListPayload) =>
      attendanceService.getPolicyList(payload),
    tagType: "EmployeeAttendancePolicyInfo",
  },
  {
    name: "addOrUpdateAttendancePolicy",
    type: "mutation",
    serviceFn: (payload: IAttendancePolicyPayload) =>
      attendanceService.addOrUpdatePolicy(payload),
    tagType: "EmployeeAttendancePolicyInfo",
  },
  {
    name: "assignAttendancePolicy",
    type: "mutation",
    serviceFn: (payload: IAssignAttendancePolicyPayload) =>
      attendanceService.assignAttendancePolicy(payload),
    tagType: "EmployeeInfo",
  },
] as const;

export const employeeAttendanceApi = rootApi.injectEndpoints({
  endpoints: (builder) => makeEndpoints(builder, employeeAttendanceEndpoints),
});

export const {
  useListAttendanceQuery,
  usePunchAttendanceEmployeeMutation,
  useUpdateAttendanceCorrectionMutation,
  useUpdateBulkAttendanceCorrectionMutation,
  useGetAttendancePolicyListQuery,
  useAddOrUpdateAttendancePolicyMutation,
  useAssignAttendancePolicyMutation,
} = employeeAttendanceApi;
